import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PasswordComponent } from '@shared/components/password/password.component';
import { SharedModule } from '@shared/modules/shared.module';
import { UiCodeBlockComponent } from '../ui-code-block/ui-code-block.component';

@Component({
	selector: 'app-ui-password',
	imports: [SharedModule, PasswordComponent, UiCodeBlockComponent],
	templateUrl: './ui-password.component.html',
	styleUrl: './ui-password.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiPasswordComponent {
	passwordControl = new FormControl('');
	disabledControl = new FormControl({ value: 'DisabledPassword123', disabled: true });

	generateCode(attrs: {
		formControl?: string;
		placeholder?: string;
		label?: string;
		helperText?: string;
		icon?: string;
		iconPosition?: string;
		size?: string;
		disabled?: boolean;
		error?: boolean;
		errorMessage?: string;
	}): string {
		let code = '<app-password';

		if (attrs.formControl) code += `\n    [formControl]="${attrs.formControl}"`;
		if (attrs.placeholder) code += `\n    placeholder="${attrs.placeholder}"`;
		if (attrs.label) code += `\n    label="${attrs.label}"`;
		if (attrs.helperText) code += `\n    helperText="${attrs.helperText}"`;
		if (attrs.icon) code += `\n    icon="${attrs.icon}"`;
		if (attrs.iconPosition) code += `\n    iconPosition="${attrs.iconPosition}"`;
		if (attrs.size) code += `\n    size="${attrs.size}"`;
		if (attrs.disabled) code += `\n    [disabled]="true"`;
		if (attrs.error) code += `\n    [error]="true"`;
		if (attrs.errorMessage) code += `\n    errorMessage="${attrs.errorMessage}"`;

		code += '\n/>';
		return code;
	}
}
